<template>
  <button
    class="cc-action-row cc-action-row--teal"
    type="button"
    @click="$emit('open')"
  >
    <div class="cc-action-icon">
      <i class="fa-solid fa-messages"></i>
    </div>

    <div class="cc-action-meta">
      <div class="cc-action-label">LL Chat (Unread)</div>
      <div class="cc-action-value">{{ unreadTotal || 0 }}</div>
    </div>

    <i class="fa-solid fa-chevron-right cc-action-chev"></i>
  </button>
</template>

<script>
export default {
  name: "LoanLaunchChatSummaryCard",
  props: {
    unreadTotal: { type: Number, default: 0 },
    latestMessage: { type: Object, default: null }
  },
  emits: ["open"]
};
</script>

<style scoped>
.ll-stat {
  width: 100%;
  height: 64px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid rgba(15, 23, 42, 0.10);
  background: #fff;
  cursor: pointer;
  user-select: none;
  margin-top:12px;
  transition: background 0.12s ease, border-color 0.12s ease, box-shadow 0.12s ease, transform 0.12s ease;
}
.ll-stat:hover {
  border-color: rgba(37, 99, 235, 0.22);
  background: rgba(37, 99, 235, 0.02);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}
.ll-stat:active {
  transform: translateY(0px) scale(0.99);
}
.ll-stat__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.ll-stat__icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.ll-stat__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.1;
}
.ll-stat__title {
  font-size: 13px;
  font-weight: 900;
  color: rgba(15, 23, 42, 0.72);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ll-stat__value {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 950;
  color: #0f172a;
  text-align: left;
}
.ll-stat__chev {
  font-size: 12px;
  opacity: 0.35;
  flex: 0 0 auto;
}
.ll-stat__ico {
  font-size: 18px;
  --fa-primary-color: rgba(37, 99, 235, 0.95);
  --fa-secondary-color: rgba(37, 99, 235, 0.22);
  --fa-secondary-opacity: 1;
  filter: drop-shadow(0 6px 14px rgba(37, 99, 235, 0.18));
}
</style>
